const useLogics = () => {
  const columns = [
    {
      title: "İşlem Tarihi",
      key: "transaction_date",
      dataIndex: "transaction_date",
      width: 250,
      fixed: true,
    },
    {
      title: "Paket Sayısı",
      key: "paket_sayisi",
      dataIndex: "paket_sayisi",
      width: 200,
    },
    {
      title: "Barkod",
      key: "barcode",
      dataIndex: "barcode",
      width: 200,
    },
    {
      title: "Koordinatlar",
      key: "loc",
      dataIndex: "loc",
      width: 200,
    },
    {
      title: "Durum",
      key: "translation_tr",
      dataIndex: "translation_tr",
      width: 200,
    },
    {
      title: "Lokasyon",
      key: "location_tr",
      dataIndex: "location_tr",
      width: 200,
    },
    {
      title: "Dosya Numarası",
      key: "dosya_numarasi",
      dataIndex: "dosya_numarasi",
      width: 200,
    },
    {
      title: "Yüklenme Tarihi",
      key: "yuklenme_tarihi",
      dataIndex: "yuklenme_tarihi",
      width: 200,
    },
    {
      title: "Fotoğraf Linki",
      key: "foto_linki",
      dataIndex: "foto_linki",
      width: 200,
    },
    {
      title: "Teslim Alan Kişi",
      key: "delivered_person",
      dataIndex: "delivered_person",
      width: 200,
    },
    {
      title: "Teslim Alan Depo Sorumlusu",
      key: "responsible_person",
      dataIndex: "responsible_person",
      width: 200,
    },
  ];

  const excelColumns = [
    {
      title: "İşlem Tarihi",
      key: "transaction_date",
    },
    {
      title: "Paket Sayısı",
      key: "paket_sayisi",
    },
    {
      title: "Barkod",
      key: "barcode",
    },
    {
      title: "Koordinatlar",
      key: "loc",
    },
    {
      title: "Durum",
      key: "translation_tr",
    },
    {
      title: "Lokasyon",
      key: "location_tr",
    },
    {
      title: "Dosya Numarası",
      key: "dosya_numarasi",
    },
    {
      title: "Yüklenme Tarihi",
      key: "yuklenme_tarihi",
    },
    {
      title: "Fotoğraf Linki",
      key: "foto_linki",
    },
    {
      title: "Teslim Alan Kişi",
      key: "delivered_person",
    },
    {
      title: "Teslim Alan Depo Sorumlusu",
      key: "responsible_person",
    },
  ];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
